// Module-scoped endpoint paths for onboarding (register, KYC, risk profile,
// source of funds, countries). Other modules must not import these.

export const ONBOARDING_ENDPOINTS = {
  REGISTER: '/api/auth/register',
  ONBOARDING_START: '/api/onboarding/start',
  ONBOARDING_STEPS: '/api/onboarding/steps',
  ONBOARDING_STEP_COMPLETE: '/api/onboarding/steps/{step_key}/complete',
  ONBOARDING_STEP_SKIP: '/api/onboarding/steps/{step_key}/skip',
  ONBOARDING_COMPLETE: '/api/onboarding/complete',
  RISK_PROFILE: '/api/onboarding/risk-profile',
  SOURCE_OF_FUNDS: '/api/onboarding/source-of-funds',
  KYC_SESSIONS: '/api/kyc/sessions',
  KYC_SESSION_START: '/api/kyc/sessions/{submission_id}/start',
  KYC_SESSION_COMPLETE: '/api/kyc/sessions/{submission_id}/complete',
  KYC_ACCESS_TOKEN: '/api/kyc/access-token',
  COUNTRIES: '/api/master/countries',
} as const
